/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState } from 'react';
import { ChallengeWrapper, ThemeWrapper } from './themes.styled';
import Container from '../container/container.component';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	CircularProgress,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Fade from 'react-reveal/Fade';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { RootState } from '&store/store';
import { colors } from '&assets/constants/colors';
import ThemeDetailsImg from '&assets/images/theme-details.png';
import SubmitButton from '../submitButton/submitButton.component';
import ImageLayer from '../imageLayer/imageLayer.component';
import { isEmpty } from 'lodash';

interface Props {
	className?: string;
	landing?: boolean;
	challenge?: any;
}

const ThemesComponent = (props: Props) => {
	const { className, landing = true, challenge } = props;
	const navigate = useNavigate();
	const challenges = useSelector(
		(state: RootState) => state.challenges.challenges
	);
	const loading = useSelector((state: RootState) => state.challenges.loading);
	const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

	const handleAccordionChange = (index: number) => {
		setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
	};

	const handleApplyClick = () => {
		if (landing)
			navigate(
				`/challenge-details/${encodeURIComponent(selectedChallenge?.pk)}`
			);
		else navigate('/submit-challenge');
	};

	const selectedChallenge = !isEmpty(challenge) ? challenge : challenges?.current[0];

	return (
		<ChallengeWrapper className={className ? className : ''}>
			<Container>
				{loading ? (
					<div className="loading-center">
						<CircularProgress size={40} color="inherit" />
					</div>
				) : (
					<Fade top cascade>
						<div className="content">
							<p className="title">{selectedChallenge?.title}</p>
							<p className="description">
								{landing
									? selectedChallenge?.summary
									: selectedChallenge?.description}
							</p>
							<div>
								{selectedChallenge?.themes?.length > 0 &&
									selectedChallenge?.themes.map((item: any, index: number) => {
										return (
											<ThemeWrapper key={index} index={index}>
												<Accordion
													key={index}
													expanded={expandedIndex === index}
													onChange={() => handleAccordionChange(index)}
												>
													<AccordionSummary
														expandIcon={<ExpandMoreIcon />}
														aria-controls="panel1a-content"
														id="panel1a-header"
													>
														<p className="accordion-title">{item.title}</p>
													</AccordionSummary>
													<AccordionDetails>
														<div className="accordion-body">
															{/* <ImageLayer
																image={ThemeDetailsImg}
																index={index}
															></ImageLayer> */}
															<div className="theme-details-text">
																<p className="accordion-content">
																	{item.description}
																</p>
																{/* <SubmitButton
																	title="APPLY NOW"
																	className={'read-more'}
																	id="read-more-btn"
																	icon={true}
																	iconColor={colors.white}
																	titleClassName={'read-more-title'}
																	handleClick={handleApplyClick}
																/> */}
															</div>
														</div>
													</AccordionDetails>
												</Accordion>
											</ThemeWrapper>
										);
									})}
							</div>
							{/* {landing && (
								<SubmitButton
									className="apply-now"
									title="APPLY NOW"
									id="submit-a-challenge-landing"
									icon={true}
									handleClick={handleApplyClick}
								/>
							)} */}
						</div>
					</Fade>
				)}
			</Container>
		</ChallengeWrapper>
	);
};

export default ThemesComponent;
